import { Colors } from './Colors';

export const Select = {
  light: {
    '&:hover': {
      backgroundColor: Colors.SecondaryHover,
    },
  },
  dark: {
    '&:hover': {
      backgroundColor: Colors.SecondaryHoverDark,
    },
  },
};
